import {createTurnstile} from "@pg-mono/turnstile";

import {RP_TURNSTILE_SIMULATION_STORAGE_KEY} from "./constants/storage_keys";
import {createTurnstileChallengeModal} from "./create_turnstile_challenge_modal";
import {rpFeatureFlagTurnstile, rpTurnstileSiteKey} from "./read_rp_environment_variables";

// Turnstile is active only when the feature flag is enabled AND a site key is configured for the
// environment. The feature flag lets us keep it off on staging/e2e, while the site key presence stays
// as defense-in-depth. A null site key makes the package short-circuit and return an undefined token,
// so protected forms keep working without a challenge.
const turnstileSiteKey = rpFeatureFlagTurnstile ? rpTurnstileSiteKey : null;

const rpTurnstile = createTurnstile({
    siteKey: turnstileSiteKey,
    createChallengeContainer: createTurnstileChallengeModal,
    simulationStorageKey: RP_TURNSTILE_SIMULATION_STORAGE_KEY
});

export const getTurnstileToken = (action: string) => rpTurnstile.getTurnstileToken(action);

export const prefetchTurnstileToken = (action: string) => rpTurnstile.prefetchTurnstileToken(action);

export const appendTurnstileToken = <T extends object>(payload: T, action: string) => rpTurnstile.appendTurnstileToken(payload, action);
import {createTurnstile} from "@pg-mono/turnstile";

import {RP_TURNSTILE_SIMULATION_STORAGE_KEY} from "./constants/storage_keys";
import {createTurnstileChallengeModal} from "./create_turnstile_challenge_modal";
import {rpFeatureFlagTurnstile, rpTurnstileSiteKey} from "./read_rp_environment_variables";

// Turnstile is active only when the feature flag is enabled AND a site key is configured for the
// environment. The feature flag lets us keep it off on staging/e2e, while the site key presence stays
// as defense-in-depth. A null site key makes the package short-circuit and return an undefined token,
// so protected forms keep working without a challenge.
const turnstileSiteKey = rpFeatureFlagTurnstile ? rpTurnstileSiteKey : null;

const rpTurnstile = createTurnstile({
    siteKey: turnstileSiteKey,
    createChallengeContainer: createTurnstileChallengeModal,
    simulationStorageKey: RP_TURNSTILE_SIMULATION_STORAGE_KEY
});

export const getTurnstileToken = (action: string) => rpTurnstile.getTurnstileToken(action);

export const prefetchTurnstileToken = (action: string) => rpTurnstile.prefetchTurnstileToken(action);

export const appendTurnstileToken = <T extends object>(payload: T, action: string) => rpTurnstile.appendTurnstileToken(payload, action);
